import getSchoolYear from './getSchoolYear'
import has from "mout/object/has";
  //Handler for previous or current groupUAs and student school year data indicator
  export default function schoolYearDataIndicator(
      assessmentId, 
      selectedStudent, 
      selectedGroupUA, 
      actions, 
      groupUAs, 
      students, 
      userLicenses, 
      match
      ) {

    //reset indicator before adding options
    actions.setIndicator({
      selectOptions: [],
      defaultValue: {},
      selectedOption: {}
    })

    let options = [];
    let years = [];
    let displayName;
    //we get the previous years options based on 'selectedStudent' and 'selectedGroupUA' from props
    if (selectedStudent) {
      const student = selectedStudent.role == 'Student' ? selectedStudent : students[selectedStudent];

      if (has(student, `assessments`) && userLicenses.length) {
         Object.keys(student.assessments).forEach(testId => {

          displayName = userLicenses.filter((test) => test.licenseSet === testId)[0]

          if(!displayName) return

          displayName = displayName.name
          years = Object.keys(student.assessments[testId]).filter((year) => year.match(/^(s{1}y{1}\d{0,})$/gm))
          years.sort(function (a, b) { return b.split('sy')[1] - a.split('sy')[1] })

          if (years.length) {
            years.forEach(year => {
              let currentYear = Number(year.split('sy')[1])
              let nextYear = currentYear + 1

              options.push({
                value: options.length,
                year: year,
                label: `${displayName} [${currentYear + "-" + nextYear}]`,
                shortName: `${displayName.match(/^(\d*\w)/gm)[0]}`,
                testId: testId,
                userAssessmentId: student.assessments[testId][year].userAssessmentId,
                student: selectedStudent.role == 'Student' ? selectedStudent.id : selectedStudent
              })
            })
          }
        })
      }

    } else if (selectedGroupUA) {
      if (groupUAs && has(groupUAs, `${selectedGroupUA}`)) {
        years = Object.keys(groupUAs[selectedGroupUA]).filter((year) => year.match(/^(s{1}y{1}\d{0,})$/gm))
        years.sort(function (a, b) { return b.split('sy')[1] - a.split('sy')[1]})

        if (years.length !== 0) {
          years.forEach(year => {
            let currentYear = Number(year.split('sy')[1])
            let nextYear = currentYear + 1
    
            Object.keys(groupUAs[selectedGroupUA][year]).forEach(testId => {

              if(!groupUAs[selectedGroupUA][year][testId].assessmentSet) return
              
              displayName = groupUAs[selectedGroupUA][year][testId].assessmentSet.displayName

              if(!displayName) return

              options.push({
                value: options.length,
                year: year,
                label: `${displayName} [${currentYear + "-" + nextYear}]`,
                shortName: `${displayName.match(/^(\d*\w)/gm)[0]}`,
                testId: testId,
                gua: selectedGroupUA
              })
    
            })
    
          })
         
        }

      }
    }
    
     // update the indicator with the relevent data
     if (options.length) {

       let currentOption = options.filter(option => option.year === getSchoolYear().year && option.testId === match)[0]

       if(currentOption){
        options.splice(currentOption.value, 1)

        actions.setIndicator({
          selectOptions: [currentOption, ...options],
          defaultValue: currentOption,
          selectedOption: currentOption
        })
       }
     }
  }


// WEBPACK FOOTER //
// ./src/helpers/schoolYearDataIndicator.js